import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { Doc } from '../_models/doc';
import { DocService } from '../_services/doc.service';
import { MetadataServiceService } from '../_services/metadata-service.service';
import { MapComponent } from 'ng-leaflet-universal';
import { Marker } from 'ng-leaflet-universal/lib/models/marker.interface';

@Component({
  selector: 'app-patients-usager',
  templateUrl: './patients-usager.component.html',
  styleUrls: ['./patients-usager.component.scss']
})
export class PatientsUsagerComponent implements AfterViewInit {

  infoBandeau = {
    'image' : "./../../assets/bandeau-vous-etes-patient-ou-usager.jpg",
    'titre' : 'VOUS ÊTES PATIENT OU USAGER',
    'breadcrumb' : 'ACCUEIL > Vous êtes patient ou usager'
  }

  docAccueil : Doc[] = [];
  docPreparer : Doc[] = [];

  get map() {
    return this._map;
  }
  private _map: any;
  @ViewChild(MapComponent) mapComponent!: MapComponent;
  markers: Marker[];

  constructor(private docService : DocService, private metadataService: MetadataServiceService) {
    this.docService.getDocsByCat('livret-accueil').subscribe(
      (docAccueil) => {
        this.docAccueil = docAccueil
      }
    );
    this.docService.getDocsByCat('preparer-son-arrive').subscribe(
      (docPreparer) => {
        this.docPreparer = docPreparer
      }
    );
    this.markers = [{
      id: "map",
      location: {
        latitude: 48.04542,
        longitude: -1.61027,
      },
    }];
  }

  ngAfterViewInit(): void {
    this.mapComponent.updateMarkers(this.markers);
    this.metadataService.updateMetadata({
      title: 'Le Patis Fraux - ' + this.infoBandeau.titre,
      description: 'Le Patis Fraux - ' + this.infoBandeau.titre
    });
  }

}
